import { useState } from 'react';
import axiosInstance from 'interceptor/axiosInstance';
import { ApiRoutes } from 'routes/routeConstants/apiRoutes';
import { useNavigate, generatePath } from 'react-router-dom';
import { AppRoutes } from 'routes/routeConstants/appRoutes';
import { RcFile } from 'antd/lib/upload';
import { notification } from 'antd';
import { useUserContext } from 'context/UserContext';
import { PrivateRouteProps } from 'enums/PrivateRouteEnums';
import { apiProps } from 'enums/AuthenticationServicesEnums';

const { USER_DETAILS } = apiProps;

const UserCompanyService = () => {
  const navigate = useNavigate();
  const { fetchCompanyImage } = useUserContext();
  const [buttonLoading, setButtonLoading] = useState<boolean>(false);

  const updateUserStatus = (status?: string, company_id?: number) => {
    const token = localStorage.getItem(PrivateRouteProps.USER);
    const userDetails = !!token && JSON.parse(localStorage.getItem(USER_DETAILS) ?? '');
    const updatedUser = {
      ...userDetails,
      status,
      company_id,
    };
    localStorage.setItem(USER_DETAILS, JSON.stringify(updatedUser));
  };

  /* Registering User */
  const registerUser = async (payload: {
    name: string;
    position: string;
    email: string;
    phone: string;
    extension: string;
    password: string;
  }) => {
    try {
      setButtonLoading(true);
      const res = await axiosInstance.post(ApiRoutes.REGISTER_USER, payload);
      localStorage.setItem('user', res.data.data.token);
      localStorage.setItem(USER_DETAILS, JSON.stringify(res.data.data.user));
      navigate(AppRoutes.COMPANY_DETAILS);
      localStorage.removeItem('signupUser');
    } catch (error) {
      throw error;
    } finally {
      setButtonLoading(false);
    }
  };

  /* set Company details*/
  const getCompanyDetails = async (
    payload: {
      name: string;
      type: string | undefined;
      revenue_range: string | undefined;
      member: string | undefined;
      referral: string | undefined;
    },
    fileObj: RcFile | undefined
  ) => {
    try {
      setButtonLoading(true);
      const res = await axiosInstance.post(ApiRoutes.COMPANY_DETAILS, payload);
      if (fileObj) {
        await uploadCompanyImage(fileObj);
      }
      const { status, id } = res?.data?.data?.company ?? {};
      updateUserStatus(status, id);
      navigate(AppRoutes.COMPANY_ADDRESS, {
        state: { id: res.data.data.company.id },
      });
    } catch (error) {
    } finally {
      setButtonLoading(false);
    }
  };

  const uploadCompanyImage = async (fileObj: RcFile) => {
    try {
      setButtonLoading(true);
      var formData = new FormData();
      formData.append('file', fileObj);
      const res = await axiosInstance.post(ApiRoutes.COMPANY_IMAGE, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      notification.success({
        message: 'Sucessfully Uploaded',
      });
      fetchCompanyImage();
    } catch (error) {
      console.log('Error is ', error);
    } finally {
      setButtonLoading(false);
    }
  };

  /* Company Address */
  const getCompanyAddress = async (
    id: number,
    payload: {
      street: string;
      province: string | undefined;
      city: string | undefined;
      postal_code: string;
      country: string;
      addressable_type: string;
      addressable_id: number;
    }
  ) => {
    try {
      if (!payload.street) return;
      if (!payload.province) return;
      if (!payload.city) return;
      if (!payload.postal_code) return;
      if (!payload.country) return;
      if (!payload.addressable_type) return;
      if (!payload.addressable_id) return;
      setButtonLoading(true);
      const url = generatePath(ApiRoutes.COMPANY_ADDRESS);
      const res = await axiosInstance.post(url, payload);
      updateUserStatus(res?.data?.address?.status);
      navigate(AppRoutes.PLAN_DETAILS);
    } catch (error) {
    } finally {
      setButtonLoading(false);
    }
  };

  return {
    buttonLoading,
    updateUserStatus,
    registerUser,
    getCompanyDetails,
    uploadCompanyImage,
    getCompanyAddress,
  };
};

export default UserCompanyService; 